<template>
  <v-container fluid :class="$style['container']">
    <v-overlay :value="loading || processing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <ToolBar :class="$style['container-header']">
      <template v-slot:left>
        <Breadcrumb :items="breadcrumbs" />
      </template>
    </ToolBar>
    <div :class="$style['container-content']">
      <v-content class="app-content">
        <div :class="$style['main-content']" id="messages-area">
          <template v-if="loaded">
            <template v-if="error">
              <div :class="$style['container-error']">
                <p>
                  <v-icon color="red darken-2">mdi-alert-circle</v-icon>
                  <span>エラーが発生しました</span>
                </p>
              </div>
            </template>
            <template v-else>
              <CCard bodyWrapper>

                <CContainer>
                  <CRow>
                  <CCol md="5">
                    <span>メーカー管理画面メンテナンスフラグ</span>
                  </CCol>
                  <CCol md="3">
                    <CSwitch
                            color="primary"
                            :checked="input && input['maker']"
                            value="primary"
                            @update:checked="changeMakerFlag"
                            labelOn="on" labelOff="off"
                    />
                  </CCol>
                </CRow>

                  <CRow>
                    <CCol md="5">
                      <span>ユーザー管理画面メンテナンスフラグ</span>
                    </CCol>
                    <CCol md="3">
                      <CSwitch
                              color="primary"
                              :checked="input && input['user']"
                              value="primary"
                              @update:checked="changeUserFlag"
                              labelOn="on" labelOff="off"
                      />
                    </CCol>
                  </CRow>

                </CContainer>

              </CCard>
            </template>
          </template>
        </div>
        <div v-if="loaded && !error" :class="$style['container-footer']">
          <v-toolbar>
            <slot name="actions.update">
              <CButton class="mx-1" color="primary" @click="onEdit">
                保存
              </CButton>
            </slot>
            <slot name="actions" />
          </v-toolbar>
        </div>
      </v-content>
    </div>
  </v-container>
</template>

<script>
  import Breadcrumb from "@/components/app/breadcrumb";
  import ToolBar from "@/components/app/toolbar";

  export default {
    components: {
      Breadcrumb,
      ToolBar
    },
    props: {
    },
    data() {
      return {
        resourceName: "maintenance",
        input: {}
      }
    },
    computed: {
      entity() {
        return this.$store.getters[`${this.resourceName}/entity/entity`];
      },
      loading() {
        return this.$store.getters[`${this.resourceName}/entity/isLoading`];
      },
      loaded() {
        return this.$store.getters[`${this.resourceName}/entity/isLoaded`];
      },
      processing() {
        return this.$store.getters[`${this.resourceName}/entity/isProcessing`];
      },
      error() {
        return this.$store.getters[`${this.resourceName}/entity/error`];
      },
      breadcrumbs() {
        return [
          {
            text: "メンテナンス設定",
            disabled: true
          }
        ];
      }
    },
    created() {
      this.$store.commit(`${this.resourceName}/entity/initialize`);
    },
    methods: {
      onEdit() {
        this.$store
          .dispatch(`${this.resourceName}/entity/update`, {
            updatedEntity: this.input
          })
          .then(() => {
          })
          .catch(() => {
            if (this.$refs.form) {
              this.$refs.form.setErrors(this.errorMessages);
            }
          });
      },
      changeMakerFlag(value, event){
        this.input.maker = value;
      },
      changeUserFlag(value, event){
        this.input.user = value;
      }
    },
    mounted() {
      this.$store.dispatch(`${this.resourceName}/entity/show`, {}).then(() => {
        let initInput = {};
        this.input = {
          ...JSON.parse(
            JSON.stringify(
              this.$store.getters[`${this.resourceName}/entity/entity`]
            )
          ),
          ...initInput
        };
      });
    }
  }
</script>

<style module lang="scss">
  $base-app-header-height: 75px;
  $base-header-height: 55px;
  $base-footer-height: 60px;

  .container.container {
    width: 100%;
    height: calc(100% - #{$base-app-header-height});
    padding: 0;
    position: relative;

    .container-header {
      height: $base-header-height !important;
    }

    .container-content {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      height: calc(100% - #{$base-header-height});
      overflow: hidden;

      .main-content {
        height: calc(
                100vh - #{$base-header-height} - #{$base-footer-height}
        );
        padding: 8px;
        overflow-y: auto;
        overflow-x: hidden;
      }

      .container-error {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        p {
          color: #ff0000;
          i {
            margin: 0 10px 0 0;
          }
          i,
          span {
            vertical-align: middle;
          }
        }
      }
    }

    .container-footer {
      height: $base-footer-height !important;
    }

    .chat-left, .chat-right {
      position: relative;
      display: inline-block;
    }

    .chat-left:before {
      content: '';
      position: absolute;
      display: block;
      z-index: 1;
      border-style: solid;
      border-color: transparent #d8dbe0;
      border-width: 10px 10px 10px 0;
      top: 50%;
      left: -10px;
      margin-top: -10px;
    }
    .chat-right:before {
      content: '';
      position: absolute;
      display: block;
      z-index: 1;
      border-style: solid;
      border-color: transparent #d8dbe0;
      border-width: 10px 0 10px 10px;
      top: 50%;
      right: -10px;
      margin-top: -10px;
    }
  }

</style>